import type {Logger} from './baseLogger';
import {createConsoleLogger} from './baseLogger';

export let logger = createConsoleLogger();

export function setLogger(newLogger: Logger) {
    logger = newLogger;
}

/**
 * A logger wrapper to always include some meta base data to the log
 *
 * @param metaBase - The meta data which will always be included into the log
 */
export const createModuleLogger = (metaBase: unknown): Logger => {
    return Object.keys(logger).reduce((log, key) => {
        const k = key as keyof Omit<Logger, 'redact' | 'addRedactPattern'>;
        log[k] = (meta: unknown, msg?: string) => {
            if (typeof meta === 'string') {
                return logger[k](metaBase, meta);
            }
            if (typeof meta === 'object') {
                return logger[k]({...meta, meta: metaBase}, msg);
            }
            return logger[k]({meta: metaBase, context: meta}, msg);
        };
        return log;
    }, {} as Logger);
};
